import { render, staticRenderFns } from "./GerencialComponent.vue?vue&type=template&id=2eb5a7a6"
import script from "./GerencialComponent.vue?vue&type=script&lang=js"
export * from "./GerencialComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports